import { FeatureFlagProvider } from '@v1/shared';
import type { User } from '@v1/shared';
import type { DehydratedState } from '@tanstack/react-query';
import type { i18n } from 'i18next';
import type { ReactNode } from 'react';
import { AuthProvider } from './AuthProvider';
import { LocaleProvider } from './LocaleProvider';
import { QueryProvider } from './QueryProvider';

interface AppProvidersProps {
	user: User | null;
	flags: Record<string, boolean>;
	i18nInstance: i18n;
	dehydratedState?: DehydratedState;
	children: ReactNode;
}

export function AppProviders({ user, flags, i18nInstance, dehydratedState, children }: AppProvidersProps) {
	return (
		<AuthProvider user={user}>
			<FeatureFlagProvider flags={flags}>
				<LocaleProvider i18nInstance={i18nInstance}>
					<QueryProvider dehydratedState={dehydratedState}>{children}</QueryProvider>
				</LocaleProvider>
			</FeatureFlagProvider>
		</AuthProvider>
	);
}
